import { designTokens } from 'theme';
import { STEP_TAB_DONE, STEP_TAB_TRIAGE } from './ui-active-session';

export type StaticStepIconKey = 'pending' | 'doneFilled';

export interface StaticStepDisplay {
  label: string;
  iconKey: StaticStepIconKey;
}

export interface StaticStepChrome {
  labelSx: {
    fontFamily: string;
    fontSize: number;
    fontWeight: number;
    letterSpacing: string;
    lineHeight: number;
    textTransform: 'uppercase' | 'none';
    display: 'inline-flex';
    alignItems: 'center';
    flexShrink: number;
  };
  iconWrapperSx: {
    display: 'inline-flex';
    alignItems: 'center';
    justifyContent: 'center';
    width: number;
    height: number;
    flexShrink: number;
  };
  iconSx: {
    fontSize: number;
  };
}

export const getStaticStepDisplay = (stepId: string): StaticStepDisplay | null => {
  if (stepId === STEP_TAB_TRIAGE) {
    return {
      label: 'Pending',
      iconKey: 'pending',
    };
  }

  if (stepId === STEP_TAB_DONE) {
    return {
      label: 'Done',
      iconKey: 'doneFilled',
    };
  }

  return null;
};

export const getStaticStepChrome = (isActive: boolean): StaticStepChrome => ({
  labelSx: {
    fontFamily: designTokens.typography.fontMono,
    fontSize: 11,
    fontWeight: isActive ? 600 : 400,
    letterSpacing: '0.04em',
    lineHeight: 1,
    textTransform: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  iconWrapperSx: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 15,
    height: 15,
    flexShrink: 0,
  },
  iconSx: {
    fontSize: 15,
  },
});
